// Mock Data for Work Order Module - Following FSD Specifications
import dayjs from "dayjs";
import {
  WorkOrderData,
  WorkOrderLine,
  ProjectTask,
  WorkBoqLine,
  Contractor,
  User,
  WorkRequest,
  Tender,
  MasterData,
  GeneralCondition,
  PaymentConditions,
  PredefinedCondition,
  ContractType,
  ContractWith,
  WorkOrderStatus,
  TaxApplicationLevel,
  RecoveryType,
  WorkOrderLineSource,
} from "../types";

// Master Data
export const mockMasterData: MasterData = {
  sites: [
    { id: "site-1", name: "Site A - Hyderabad Downtown" },
    // { id: "site-2", name: "Site B - Bangalore Suburban" },
    // { id: "site-3", name: "Site C - Chennai Industrial" },
    // { id: "site-4", name: "Site D - Mumbai Metro" }
  ],
  projects: [
    { id: "proj-1", name: "Highrise Tower Phase 1", siteId: "site-1" },
    { id: "proj-2", name: "Urban Complex Tower A", siteId: "site-1" },
    { id: "proj-3", name: "Green Meadows Villa Project", siteId: "site-2" },
    { id: "proj-4", name: "Industrial Park Development", siteId: "site-3" },
    { id: "proj-5", name: "Metro Station Complex", siteId: "site-4" },
  ],
  activities: [
    // Project 1: Highrise Tower Phase 1
    { id: "act-1", name: "Foundation & Excavation Work", projectId: "proj-1" },
    { id: "act-2", name: "Structure & RCC Work", projectId: "proj-1" },
    { id: "act-3", name: "Finishing & Interior Work", projectId: "proj-1" },
    { id: "act-4", name: "MEP Installation", projectId: "proj-1" },
    { id: "act-5", name: "External Works & Landscaping", projectId: "proj-1" },

    // Project 2: Urban Complex Tower A
    { id: "act-6", name: "Site Preparation & Foundation", projectId: "proj-2" },
    { id: "act-7", name: "Structural Works", projectId: "proj-2" },
    { id: "act-8", name: "Architectural Finishing", projectId: "proj-2" },
    { id: "act-9", name: "MEP Systems Installation", projectId: "proj-2" },

    // Project 3: Green Meadows Villa Project
    { id: "act-10", name: "Site Development", projectId: "proj-3" },
    { id: "act-11", name: "Villa Construction", projectId: "proj-3" },
    { id: "act-12", name: "Landscaping & External Work", projectId: "proj-3" },
    { id: "act-13", name: "Utilities Installation", projectId: "proj-3" },

    // Project 4: Industrial Park Development
    { id: "act-14", name: "Infrastructure Development", projectId: "proj-4" },
    {
      id: "act-15",
      name: "Industrial Building Construction",
      projectId: "proj-4",
    },
    { id: "act-16", name: "Heavy Equipment Installation", projectId: "proj-4" },

    // Project 5: Metro Station Complex
    { id: "act-17", name: "Metro Infrastructure", projectId: "proj-5" },
    {
      id: "act-18",
      name: "Station Building Construction",
      projectId: "proj-5",
    },
    { id: "act-19", name: "Platform & Track Works", projectId: "proj-5" },
    {
      id: "act-20",
      name: "Electrical & Signaling Systems",
      projectId: "proj-5",
    },
  ],
  workBoqs: [
    {
      id: "boq-1",
      title: "Civil Works BOQ - Phase 1",
      siteId: "site-1",
      status: "Approved",
    },
    {
      id: "boq-2",
      title: "MEP Works BOQ - Tower A",
      siteId: "site-1",
      status: "Approved",
    },
    {
      id: "boq-3",
      title: "Finishing Works BOQ",
      siteId: "site-2",
      status: "Approved",
    },
    {
      id: "boq-4",
      title: "Infrastructure BOQ",
      siteId: "site-3",
      status: "Draft",
    },
  ],
  contractors: [
    {
      id: "cont-1",
      companyName: "L&T Construction Ltd",
      contactPerson: "Rajesh Kumar",
      email: "rajesh@lnt.com",
      phone: "+91-9876543210",
      siteIds: ["site-1", "site-2", "site-3"],
    },
    {
      id: "cont-2",
      companyName: "Tata Projects Ltd",
      contactPerson: "Priya Sharma",
      email: "priya@tataprojects.com",
      phone: "+91-9876543211",
      siteIds: ["site-1", "site-4"],
    },
    {
      id: "cont-3",
      companyName: "Shapoorji Pallonji Group",
      contactPerson: "Amit Patel",
      email: "amit@shapoorji.com",
      phone: "+91-9876543212",
      siteIds: ["site-2", "site-3"],
    },
    {
      id: "cont-4",
      companyName: "NCC Limited",
      contactPerson: "Suresh Reddy",
      email: "suresh@ncclimited.com",
      phone: "+91-9876543213",
      siteIds: ["site-1", "site-2", "site-4"],
    },
  ],
  workCategories: [
    { id: "cat-1", name: "Civil Work" },
    { id: "cat-2", name: "Electrical Work" },
    { id: "cat-3", name: "Plumbing Work" },
    { id: "cat-4", name: "HVAC Work" },
    { id: "cat-5", name: "Excavation", parentId: "cat-1" },
    { id: "cat-6", name: "RCC Work", parentId: "cat-1" },
    { id: "cat-7", name: "Masonry Work", parentId: "cat-1" },
    { id: "cat-8", name: "Internal Wiring", parentId: "cat-2" },
    { id: "cat-9", name: "Panel Installation", parentId: "cat-2" },
    { id: "cat-10", name: "Pipe Installation", parentId: "cat-3" },
    { id: "cat-11", name: "Fixture Installation", parentId: "cat-3" },
  ],
  uomList: [
    { id: "uom-1", name: "Square Feet", code: "Sqft" },
    { id: "uom-2", name: "Meter", code: "Mtr" },
    { id: "uom-3", name: "Kilogram", code: "Kg" },
    { id: "uom-4", name: "Number", code: "Nos" },
    { id: "uom-5", name: "Cubic Meter", code: "Cum" },
    { id: "uom-6", name: "Running Meter", code: "Rmt" },
    { id: "uom-7", name: "Square Meter", code: "Sqm" },
  ],
  taxTypes: [
    { id: "tax-1", name: "GST 18%", percentage: 18, code: "GST18" },
    { id: "tax-2", name: "GST 12%", percentage: 12, code: "GST12" },
    { id: "tax-3", name: "GST 5%", percentage: 5, code: "GST5" },
    { id: "tax-4", name: "CGST 9%", percentage: 9, code: "CGST9" },
    { id: "tax-5", name: "SGST 9%", percentage: 9, code: "SGST9" },
  ],
  users: [
    {
      id: "user-1",
      name: "John Smith",
      email: "john.smith@company.com",
      role: "Project Manager",
    },
    {
      id: "user-2",
      name: "Priya Patel",
      email: "priya.patel@company.com",
      role: "Site Engineer",
    },
    {
      id: "user-3",
      name: "Rajesh Kumar",
      email: "rajesh.kumar@company.com",
      role: "Procurement Head",
    },
    {
      id: "user-4",
      name: "Suma Reddy",
      email: "suma.reddy@company.com",
      role: "QS Manager",
    },
    {
      id: "user-5",
      name: "Anil Rao",
      email: "anil.rao@company.com",
      role: "Construction Manager",
    },
  ],
  workRequests: [
    {
      id: "wr-1",
      workRequestNumber: "WR-2025-001",
      workRequestTitle: "Foundation Work Package",
      siteId: "site-1",
      status: "Approved",
    },
    {
      id: "wr-2",
      workRequestNumber: "WR-2025-002",
      workRequestTitle: "MEP Installation Phase 1",
      siteId: "site-1",
      status: "Approved",
    },
    {
      id: "wr-3",
      workRequestNumber: "WR-2025-003",
      workRequestTitle: "External Finishing Work",
      siteId: "site-2",
      status: "Approved",
    },
  ],
  tenders: [
    {
      id: "tender-1",
      tenderNumber: "TND-2025-001",
      tenderTitle: "Civil Construction Package",
      siteId: "site-1",
      status: "Closed",
    },
    {
      id: "tender-2",
      tenderNumber: "TND-2025-002",
      tenderTitle: "MEP Works Package",
      siteId: "site-1",
      status: "Closed",
    },
    {
      id: "tender-3",
      tenderNumber: "TND-2025-003",
      tenderTitle: "Infrastructure Development",
      siteId: "site-3",
      status: "Open",
    },
  ],
};

// Project Tasks for Work Order Creation (Option 1)
export const mockProjectTasks: ProjectTask[] = [
  // Foundation & Excavation Work (act-1)
  {
    taskId: "PM101",
    taskName: "Foundation Digging",
    workCategory: "Excavation",
    description: "Basement foundation excavation work",
    quantity: 500,
    uom: "Cum",
    weightagePercentage: 15,
    rate: 120,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-1",
    activityName: "Foundation & Excavation Work",
    projectId: "proj-1",
    isSelected: false,
  },
  {
    taskId: "PM102",
    taskName: "Site Leveling",
    workCategory: "Excavation",
    description: "Site preparation and leveling work",
    quantity: 200,
    uom: "Sqm",
    weightagePercentage: 8,
    rate: 50,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-1",
    activityName: "Foundation & Excavation Work",
    projectId: "proj-1",
    isSelected: false,
  },

  // Structure & RCC Work (act-2)
  {
    taskId: "PM201",
    taskName: "RCC Slab Work",
    workCategory: "RCC Work",
    description: "Ground floor slab casting",
    quantity: 250,
    uom: "Sqft",
    weightagePercentage: 10,
    rate: 150,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-2",
    activityName: "Structure & RCC Work",
    projectId: "proj-1",
    isSelected: false,
  },
  {
    taskId: "PM202",
    taskName: "Column Construction",
    workCategory: "RCC Work",
    description: "RCC column construction for ground floor",
    quantity: 20,
    uom: "Nos",
    weightagePercentage: 8,
    rate: 2500,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-2",
    activityName: "Structure & RCC Work",
    projectId: "proj-1",
    isSelected: false,
  },

  // Finishing & Interior Work (act-3)
  {
    taskId: "PM301",
    taskName: "Masonry Work",
    workCategory: "Masonry Work",
    description: "Brick masonry for external walls",
    quantity: 300,
    uom: "Sqft",
    weightagePercentage: 12,
    rate: 80,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-3",
    activityName: "Finishing & Interior Work",
    projectId: "proj-1",
    isSelected: false,
  },
  {
    taskId: "PM302",
    taskName: "Interior Plastering",
    workCategory: "Masonry Work",
    description: "Internal wall plastering work",
    quantity: 500,
    uom: "Sqft",
    weightagePercentage: 10,
    rate: 60,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-3",
    activityName: "Finishing & Interior Work",
    projectId: "proj-1",
    isSelected: false,
  },

  // MEP Installation (act-4)
  {
    taskId: "PM401",
    taskName: "Electrical Wiring",
    workCategory: "Internal Wiring",
    description: "Internal electrical wiring installation",
    quantity: 1000,
    uom: "Mtr",
    weightagePercentage: 15,
    rate: 45,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-4",
    activityName: "MEP Installation",
    projectId: "proj-1",
    isSelected: false,
  },
  {
    taskId: "PM402",
    taskName: "Plumbing Installation",
    workCategory: "Pipe Installation",
    description: "Water supply and drainage pipe installation",
    quantity: 500,
    uom: "Mtr",
    weightagePercentage: 12,
    rate: 70,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-4",
    activityName: "MEP Installation",
    projectId: "proj-1",
    isSelected: false,
  },

  // Tasks for Project 2 - Urban Complex Tower A
  {
    taskId: "PM501",
    taskName: "Foundation Work",
    workCategory: "Excavation",
    description: "Tower foundation excavation and concrete work",
    quantity: 300,
    uom: "Cum",
    weightagePercentage: 20,
    rate: 150,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-6",
    activityName: "Site Preparation & Foundation",
    projectId: "proj-2",
    isSelected: false,
  },
  {
    taskId: "PM502",
    taskName: "Structural Steel Work",
    workCategory: "RCC Work",
    description: "Steel structure installation for tower",
    quantity: 50,
    uom: "Tons",
    weightagePercentage: 25,
    rate: 5000,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-7",
    activityName: "Structural Works",
    projectId: "proj-2",
    isSelected: false,
  },

  // Tasks for Project 3 - Green Meadows Villa Project
  {
    taskId: "PM601",
    taskName: "Villa Foundation",
    workCategory: "Excavation",
    description: "Individual villa foundation work",
    quantity: 100,
    uom: "Cum",
    weightagePercentage: 18,
    rate: 180,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-10",
    activityName: "Site Development",
    projectId: "proj-3",
    isSelected: false,
  },
  {
    taskId: "PM602",
    taskName: "Garden Landscaping",
    workCategory: "Civil Work",
    description: "Villa garden and landscape development",
    quantity: 2000,
    uom: "Sqft",
    weightagePercentage: 15,
    rate: 25,
    taxType: "GST 18%",
    taxPercentage: 18,
    activityId: "act-12",
    activityName: "Landscaping & External Work",
    projectId: "proj-3",
    isSelected: false,
  },
];

// Work BOQ Lines for Work Order Creation (Option 2)
export const mockWorkBoqLines: WorkBoqLine[] = [
  {
    lineId: "BOQ101",
    taskName: "Foundation Digging",
    workCategory: "Excavation",
    approvedQuantity: 500,
    allocatedQuantity: 200,
    pendingQuantity: 300,
    uom: "Cum",
    weightagePercentage: 10,
    rate: 120,
    taxType: "GST 18%",
    taxPercentage: 18,
    workBoqId: "boq-1",
    isSelected: false,
  },
  {
    lineId: "BOQ102",
    taskName: "Masonry Work",
    workCategory: "Masonry Work",
    approvedQuantity: 800,
    allocatedQuantity: 300,
    pendingQuantity: 500,
    uom: "Sqft",
    weightagePercentage: 20,
    rate: 80,
    taxType: "GST 18%",
    taxPercentage: 18,
    workBoqId: "boq-1",
    isSelected: false,
  },
  {
    lineId: "BOQ103",
    taskName: "RCC Column Work",
    workCategory: "RCC Work",
    approvedQuantity: 25,
    allocatedQuantity: 10,
    pendingQuantity: 15,
    uom: "Nos",
    weightagePercentage: 15,
    rate: 2200,
    taxType: "GST 18%",
    taxPercentage: 18,
    workBoqId: "boq-1",
    isSelected: false,
  },
  {
    lineId: "BOQ201",
    taskName: "Electrical Wiring",
    workCategory: "Internal Wiring",
    approvedQuantity: 1000,
    allocatedQuantity: 400,
    pendingQuantity: 600,
    uom: "Mtr",
    weightagePercentage: 8,
    rate: 45,
    taxType: "GST 18%",
    taxPercentage: 18,
    workBoqId: "boq-2",
    isSelected: false,
  },
];

// Predefined General Conditions (FSD Section C - All 20 Conditions)
export const predefinedConditions: PredefinedCondition[] = [
  {
    id: "ScopePerformance",
    name: "ScopePerformance",
    defaultContent: "", // No default templates as per requirement
    order: 1,
  },
  {
    id: "DiscrepanciesAdjustment",
    name: "Discrepancies & Adjustment of Errors",
    defaultContent: "",
    order: 2,
  },
  {
    id: "SecurityDeposits",
    name: "Security Deposits",
    defaultContent: "",
    order: 3,
  },
  {
    id: "DeviationVariation",
    name: "Deviation / Variation Extent & Pricing",
    defaultContent: "",
    order: 4,
  },
  {
    id: "SuspensionWorks",
    name: "Suspension of Works",
    defaultContent: "",
    order: 5,
  },
  {
    id: "TimeExtension",
    name: "Time & Extension for Delay",
    defaultContent: "",
    order: 6,
  },
  {
    id: "MaterialsLabour",
    name: "Materials & Labour",
    defaultContent: "",
    order: 7,
  },
  {
    id: "SettingOutWorks",
    name: "Setting Out the Works",
    defaultContent: "",
    order: 8,
  },
  {
    id: "CompletionCertificate",
    name: "Completion Certificate",
    defaultContent: "",
    order: 9,
  },
  {
    id: "CompensationDelay",
    name: "Compensation for Delay",
    defaultContent: "",
    order: 10,
  },
  {
    id: "ContractorLiability",
    name: "Contractor's Liability & Insurance",
    defaultContent: "",
    order: 11,
  },
  {
    id: "ReductionScope",
    name: "Reduction in Scope of Work",
    defaultContent: "",
    order: 12,
  },
  {
    id: "TerminationContract",
    name: "Termination of Contract for Death",
    defaultContent: "",
    order: 13,
  },
  {
    id: "CancellationContract",
    name: "Cancellation of Contract in Full or in Part",
    defaultContent: "",
    order: 14,
  },
  {
    id: "LiabilityDamage",
    name: "Liability for Damage / Defects",
    defaultContent: "",
    order: 15,
  },
  {
    id: "LandContractor",
    name: "Land for Contractor's Office/Store/Workshop",
    defaultContent: "",
    order: 16,
  },
  {
    id: "PowerSupply",
    name: "Power Supply",
    defaultContent: "",
    order: 17,
  },
  {
    id: "ValuationPayment",
    name: "Valuation & Payment",
    defaultContent: "",
    order: 18,
  },
  {
    id: "ArbitrationLaws",
    name: "Arbitration & Laws",
    defaultContent: "",
    order: 19,
  },
  {
    id: "ContractorLabourRegulations",
    name: "Contractor's Labour Regulations",
    defaultContent: "",
    order: 20,
  },
  {
    id: "Others",
    name: "Others",
    defaultContent: "",
    order: 21,
  },
];

// Sample Work Order Lines
const sampleWorkOrderLines: WorkOrderLine[] = [
  {
    id: "wol-1",
    lineNumber: "WOL-001",
    workCategory: "Excavation",
    subCategory: "Foundation Excavation",
    taskTitle: "Foundation Digging",
    taskDescription: "Basement foundation excavation for Tower A",
    quantity: 300,
    uom: "Cum",
    weightagePercentage: 10,
    rate: 200,
    taxType: "GST 18%",
    taxPercentage: 18,
    taxAmount: 10800,
    totalAmount: 70800,
    source: WorkOrderLineSource.ProjectManagement,
    sourceId: "PM101",
    sectionId: "basement",
    executedQuantity: 0,
    remainingQuantity: 300,
    completionPercentage: 0,
  },
  {
    id: "wol-2",
    lineNumber: "WOL-002",
    workCategory: "Masonry Work",
    subCategory: "Brick Work",
    taskTitle: "External Wall Masonry",
    taskDescription: "Brick masonry work for external walls",
    quantity: 800,
    uom: "Sqft",
    weightagePercentage: 20,
    rate: 120,
    taxType: "GST 18%",
    taxPercentage: 18,
    taxAmount: 17280,
    totalAmount: 113280,
    source: WorkOrderLineSource.WorkBOQ,
    sourceId: "BOQ102",
    sectionId: "superstructure",
    executedQuantity: 0,
    remainingQuantity: 800,
    completionPercentage: 0,
  },
];

// Sample General Conditions
const sampleGeneralConditions: GeneralCondition[] = [
  {
    id: "gc-active-1",
    conditionName: "Scope & Performance",
    conditionContent:
      "The contractor shall execute all works as per the approved drawings, specifications, and BOQ. All work shall be performed to the highest standards of workmanship and quality.",
    isActive: true,
    order: 1,
  },
  {
    id: "gc-active-3",
    conditionName: "Security Deposits",
    conditionContent:
      "A security deposit equivalent to 5% of the contract value shall be maintained throughout the project duration and released upon successful completion.",
    isActive: true,
    order: 3,
  },
  {
    id: "gc-active-6",
    conditionName: "Time & Extension for Delay",
    conditionContent:
      "Time is the essence of the contract. Extensions shall only be granted for delays attributable to the employer or force majeure conditions.",
    isActive: true,
    order: 6,
  },
];

// Sample Payment Conditions
const samplePaymentConditions: PaymentConditions = {
  mobilizationAdvance: {
    isPercentOfContract: true,
    percentageOfContract: 10,
    interestCharged: true,
    interestRate: 12,
    recoveryType: RecoveryType.EachRABill,
  },
  retentionAmount: {
    isPercentOfRABill: true,
    percentageOfRABill: 5,
    releaseDate: "2026-01-06",
  },
  onHoldAmount: {
    isPercentOfContract: false,
    holdAmountValue: 50000,
    releaseDate: "2026-06-30",
  },
  payOnWorkCompletion: true,
};

// Mock Work Orders (FSD Sample Data)
export const mockWorkOrders: WorkOrderData[] = [
  {
    id: "wo-1",
    workOrderNumber: "WO/2025-26/HYD/0042",
    linkedWorkRequest: "WR-2025-001",
    linkedTender: "TND-2025-001",
    contractorApplicationAccess: false,
    contractDate: "2025-08-01",
    workOrderTitle: "Core & Shell -- Tower B Construction",
    workOrderDescription:
      "Complete core and shell construction work for Tower B including foundation, structure, and basic MEP installation",
    siteId: "site-1",
    siteName: "Site A - Hyderabad Downtown",
    projectId: "proj-1",
    projectName: "Highrise Tower Phase 1",
    contractType: ContractType.Construction,
    contractWith: ContractWith.GeneralContractor,
    contractorId: "cont-1",
    contractorName: "L&T Construction Ltd",
    workOrderOwner: "user-1",
    plannedStartDate: "2025-08-10",
    plannedEndDate: "2026-02-15",
    approvalRequired: true,
    enableTax: true,
    taxApplicationLevel: TaxApplicationLevel.Line,
    status: WorkOrderStatus.InExecution,
    workOrderLines: sampleWorkOrderLines,
    generalConditions: sampleGeneralConditions,
    paymentConditions: samplePaymentConditions,
    totalValue: 1896000,
    taxAmount: 341280,
    grossValue: 2237280,
    createdAt: dayjs().subtract(45, "days").format("YYYY-MM-DD HH:mm:ss"),
    createdBy: "user-1",
    updatedAt: dayjs().subtract(2, "days").format("YYYY-MM-DD HH:mm:ss"),
  },
  {
    id: "wo-2",
    workOrderNumber: "WO/2025-26/HYD/0031",
    linkedWorkRequest: "WR-2025-002",
    contractDate: "2025-09-15",
    workOrderTitle: "Podium Finishes",
    contractorApplicationAccess: false,
    workOrderDescription:
      "Interior and exterior finishing work for podium area",
    siteId: "site-1",
    siteName: "Site A - Hyderabad Downtown",
    projectId: "proj-2",
    projectName: "Urban Complex Tower A",
    contractType: ContractType.Construction,
    contractWith: ContractWith.SubContractor,
    contractorId: "cont-3",
    contractorName: "Shapoorji Pallonji Group",
    workOrderOwner: "user-2",
    plannedStartDate: "2025-09-18",
    plannedEndDate: "2025-12-15",
    approvalRequired: true,
    enableTax: true,
    taxApplicationLevel: TaxApplicationLevel.Line,
    status: WorkOrderStatus.OnHold,
    workOrderLines: [
      {
        id: "wol-3",
        lineNumber: "WOL-003",
        workCategory: "Finishing Work",
        taskTitle: "Interior Painting",
        taskDescription: "Premium interior painting work",
        quantity: 500,
        uom: "Sqft",
        weightagePercentage: 15,
        rate: 180,
        taxType: "GST 18%",
        taxPercentage: 18,
        taxAmount: 16200,
        totalAmount: 106200,
        source: WorkOrderLineSource.NewWorkLine,
        sectionId: "interior",
        executedQuantity: 190,
        remainingQuantity: 310,
        completionPercentage: 38,
      },
    ],
    generalConditions: [sampleGeneralConditions[0]],
    paymentConditions: {
      mobilizationAdvance: {
        isPercentOfContract: true,
        percentageOfContract: 8,
        interestCharged: false,
        recoveryType: RecoveryType.EachRABill,
      },
      retentionAmount: {
        isPercentOfRABill: true,
        percentageOfRABill: 5,
        releaseDate: "2026-03-15",
      },
      onHoldAmount: {
        isPercentOfContract: false,
        holdAmountValue: 0,
        releaseDate: "2026-03-15",
      },
      payOnWorkCompletion: false,
    },
    totalValue: 949153,
    taxAmount: 170847,
    grossValue: 1120000,
    createdAt: dayjs().subtract(30, "days").format("YYYY-MM-DD HH:mm:ss"),
    createdBy: "user-2",
    updatedAt: dayjs().subtract(5, "days").format("YYYY-MM-DD HH:mm:ss"),
  },
  {
    id: "wo-3",
    workOrderNumber: "WO/2025-26/BLR/0018",
    contractDate: "2025-10-01",
    workOrderTitle: "MEP Package - Complete Installation",
    workOrderDescription:
      "Complete MEP (Mechanical, Electrical, Plumbing) installation for the building",
    siteId: "site-2",
    siteName: "Site B - Bangalore Suburban",
    projectId: "proj-3",
    contractorApplicationAccess: false,
    projectName: "Green Meadows Villa Project",
    contractType: ContractType.Construction,
    contractWith: ContractWith.GeneralContractor,
    contractorId: "cont-2",
    contractorName: "Tata Projects Ltd",
    workOrderOwner: "user-3",
    plannedStartDate: "2025-10-15",
    plannedEndDate: "2026-01-15",
    approvalRequired: true,
    enableTax: true,
    taxApplicationLevel: TaxApplicationLevel.Header,
    status: WorkOrderStatus.PendingApproval,
    workOrderLines: [
      {
        id: "wol-4",
        lineNumber: "WOL-004",
        workCategory: "Electrical Work",
        taskTitle: "Main Panel Installation",
        taskDescription:
          "Installation of main electrical panels and distribution boards",
        quantity: 5,
        uom: "Nos",
        weightagePercentage: 25,
        rate: 45000,
        taxType: "GST 18%",
        taxPercentage: 18,
        taxAmount: 0, // Will be calculated at WO level
        totalAmount: 225000,
        source: WorkOrderLineSource.NewWorkLine,
        sectionId: "electrical",
        executedQuantity: 0,
        remainingQuantity: 5,
        completionPercentage: 0,
      },
      {
        id: "wol-5",
        lineNumber: "WOL-005",
        workCategory: "Plumbing Work",
        taskTitle: "Main Pipeline Installation",
        taskDescription:
          "Installation of main water supply and drainage pipelines",
        quantity: 200,
        uom: "Mtr",
        weightagePercentage: 30,
        rate: 850,
        taxType: "GST 18%",
        taxPercentage: 18,
        taxAmount: 0, // Will be calculated at WO level
        totalAmount: 170000,
        source: WorkOrderLineSource.NewWorkLine,
        sectionId: "plumbing",
        executedQuantity: 0,
        remainingQuantity: 200,
        completionPercentage: 0,
      },
    ],
    generalConditions: [sampleGeneralConditions[0], sampleGeneralConditions[1]],
    paymentConditions: {
      mobilizationAdvance: {
        isPercentOfContract: true,
        percentageOfContract: 15,
        interestCharged: true,
        interestRate: 10,
        recoveryType: RecoveryType.EachRABill,
      },
      retentionAmount: {
        isPercentOfRABill: true,
        percentageOfRABill: 10,
        releaseDate: "2026-07-15",
      },
      onHoldAmount: {
        isPercentOfContract: true,
        percentageOfContract: 2,
        releaseDate: "2026-04-15",
      },
      payOnWorkCompletion: true,
    },
    totalValue: 2924576,
    taxAmount: 525424,
    grossValue: 3450000,
    createdAt: dayjs().subtract(10, "days").format("YYYY-MM-DD HH:mm:ss"),
    createdBy: "user-3",
    updatedAt: dayjs().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss"),
  },
];

// Helper Functions
export const getMasterData = () => mockMasterData;

export const getPredefinedConditions = () => predefinedConditions;

export const getWorkOrders = (filters?: {
  searchText?: string;
  siteIds?: string[];
  statuses?: WorkOrderStatus[];
  contractTypes?: ContractType[];
  contractorIds?: string[];
}) => {
  let filtered = [...mockWorkOrders];

  if (filters?.searchText) {
    const search = filters.searchText.toLowerCase();
    filtered = filtered.filter(
      (wo) =>
        wo.workOrderNumber.toLowerCase().includes(search) ||
        wo.workOrderTitle.toLowerCase().includes(search) ||
        wo.contractorName.toLowerCase().includes(search)
    );
  }

  if (filters?.siteIds?.length) {
    filtered = filtered.filter((wo) => filters.siteIds!.includes(wo.siteId));
  }

  if (filters?.statuses?.length) {
    filtered = filtered.filter((wo) => filters.statuses!.includes(wo.status));
  }

  if (filters?.contractTypes?.length) {
    filtered = filtered.filter((wo) =>
      filters.contractTypes!.includes(wo.contractType)
    );
  }

  if (filters?.contractorIds?.length) {
    filtered = filtered.filter((wo) =>
      filters.contractorIds!.includes(wo.contractorId)
    );
  }

  return filtered;
};

export const getWorkOrderById = (id: string) => {
  return mockWorkOrders.find((wo) => wo.id === id);
};

export const getProjectTasks = (
  projectId?: string,
  activityId?: string,
  workCategoryId?: string
) => {
  let tasks = [...mockProjectTasks];

  if (projectId) {
    tasks = tasks.filter((task) => task.projectId === projectId);
  }

  if (activityId) {
    tasks = tasks.filter((task) => task.activityId === activityId);
  }

  if (workCategoryId) {
    const category = mockMasterData.workCategories.find(
      (c) => c.id === workCategoryId
    );
    if (category) {
      tasks = tasks.filter((task) => task.workCategory === category.name);
    }
  }

  return tasks;
};

export const getWorkBoqLines = (
  workBoqId?: string,
  workCategoryId?: string
) => {
  let lines = [...mockWorkBoqLines];

  if (workBoqId) {
    lines = lines.filter((line) => line.workBoqId === workBoqId);
  }

  if (workCategoryId) {
    const category = mockMasterData.workCategories.find(
      (c) => c.id === workCategoryId
    );
    if (category) {
      lines = lines.filter((line) => line.workCategory === category.name);
    }
  }

  return lines;
};

export const getContractorsBySite = (siteId: string) => {
  return mockMasterData.contractors.filter((contractor) =>
    contractor.siteIds.includes(siteId)
  );
};

export const getProjectsBySite = (siteId: string) => {
  return mockMasterData.projects.filter((project) => project.siteId === siteId);
};

export const getActivitiesByProject = (projectId: string) => {
  const activities = mockMasterData.activities.filter(
    (activity) => activity.projectId === projectId
  );
  console.log(
    `Found ${activities.length} activities for project ${projectId}:`,
    activities
  );
  return activities;
};

export const getWorkBoqsBySite = (siteId: string) => {
  return mockMasterData.workBoqs.filter(
    (boq) => boq.siteId === siteId && boq.status === "Approved"
  );
};

export const getOpenWorkRequests = (siteId?: string) => {
  let requests = mockMasterData.workRequests.filter(
    (wr) => wr.status === "Approved"
  );
  if (siteId) {
    requests = requests.filter((wr) => wr.siteId === siteId);
  }
  return requests;
};

export const getOpenTenders = (siteId?: string) => {
  let tenders = mockMasterData.tenders.filter(
    (t) => t.status === "Closed" || t.status === "Open"
  );
  if (siteId) {
    tenders = tenders.filter((t) => t.siteId === siteId);
  }
  return tenders;
};

export const createWorkOrder = (
  data: Partial<WorkOrderData>
): WorkOrderData => {
  const newId = `wo-${Date.now()}`;
  const newWorkOrder: WorkOrderData = {
    id: newId,
    workOrderNumber: data.workOrderNumber || generateWorkOrderNumber(),
    linkedWorkRequest: data.linkedWorkRequest,
    linkedTender: data.linkedTender,
    contractDate: data.contractDate || "",
    workOrderTitle: data.workOrderTitle || "",
    workOrderDescription: data.workOrderDescription,
    siteId: data.siteId || "",
    siteName: data.siteName || "",
    projectId: data.projectId,
    contractorApplicationAccess: data.contractorApplicationAccess || false,
    projectName: data.projectName,
    contractType: data.contractType || ContractType.Construction,
    contractWith: data.contractWith || ContractWith.GeneralContractor,
    contractorId: data.contractorId || "",
    contractorName: data.contractorName || "",
    workOrderOwner: data.workOrderOwner || "",
    plannedStartDate: data.plannedStartDate || "",
    plannedEndDate: data.plannedEndDate || "",
    approvalRequired: data.approvalRequired || false,
    enableTax: data.enableTax || false,
    taxApplicationLevel: data.taxApplicationLevel,
    status: data.approvalRequired
      ? WorkOrderStatus.PendingApproval
      : WorkOrderStatus.Draft,
    workOrderLines: data.workOrderLines || [],
    generalConditions: data.generalConditions || [],
    paymentConditions: data.paymentConditions || {
      mobilizationAdvance: {
        isPercentOfContract: false,
        interestCharged: false,
        recoveryType: RecoveryType.EachRABill,
      },
      retentionAmount: {
        isPercentOfRABill: false,
        releaseDate: "",
      },
      onHoldAmount: {
        isPercentOfContract: false,
        releaseDate: "",
      },
      payOnWorkCompletion: false,
    },
    totalValue: data.totalValue || 0,
    taxAmount: data.taxAmount || 0,
    grossValue: data.grossValue || 0,
    createdAt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    createdBy: data.createdBy || "Current User",
  };

  mockWorkOrders.push(newWorkOrder);
  return newWorkOrder;
};

export const updateWorkOrder = (id: string, data: Partial<any>) => {
  const index = mockWorkOrders.findIndex((wo) => wo.id === id);
  if (index !== -1) {
    mockWorkOrders[index] = {
      ...mockWorkOrders[index],
      ...data,
      updatedAt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    };
    return mockWorkOrders[index];
  }
  return null;
};

export const deleteWorkOrder = (id: string) => {
  const index = mockWorkOrders.findIndex((wo) => wo.id === id);
  if (index !== -1) {
    mockWorkOrders.splice(index, 1);
    return true;
  }
  return false;
};

export const generateWorkOrderNumber = () => {
  const year = new Date().getFullYear();
  const month = String(new Date().getMonth() + 1).padStart(2, "0");
  const timestamp = Date.now().toString();
  const sequence = timestamp.slice(-4);
  return `WO/${year}-${month}/SITE/${sequence}`;
};

export const calculateWorkOrderTotals = (
  lines: WorkOrderLine[],
  enableTax: boolean,
  taxApplicationLevel?: TaxApplicationLevel
) => {
  let totalValue = 0;
  let taxAmount = 0;

  lines.forEach((line: any) => {
    const lineTotal = line.quantity * line.rate;
    totalValue += lineTotal;

    if (enableTax) {
      if (taxApplicationLevel === TaxApplicationLevel.Line) {
        taxAmount += (lineTotal * line.taxPercentage) / 100;
      }
    }
  });

  // If tax is at WO level, apply a default rate (e.g., 18%)
  if (enableTax && taxApplicationLevel === TaxApplicationLevel.Header) {
    taxAmount = (totalValue * 18) / 100; // Default 18% GST
  }

  return {
    totalValue,
    taxAmount,
    grossValue: totalValue + taxAmount,
  };
};
